import React from 'react';
import { NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import BrandLogo from '../common/BrandLogo';

const { FiGrid, FiTruck, FiMap, FiAlertTriangle, FiInfo, FiFileText, FiSettings } = FiIcons;

const navItems = [
  { path: '/', icon: FiGrid, label: 'Command Core' },
  { path: '/vehicles', icon: FiTruck, label: 'Fleet Status' },
  { path: '/routes', icon: FiMap, label: 'Active Routes' },
  { path: '/issues', icon: FiAlertTriangle, label: 'Issue Log' },
  { path: '/reports', icon: FiFileText, label: 'Intelligence Reports' },
  { path: '/intel', icon: FiInfo, label: 'System Intel' },
  { path: '/settings', icon: FiSettings, label: 'Settings' },
];

const Sidebar = () => {
  return (
    <aside className="w-64 h-screen hud-panel border-y-0 border-l-0 fixed left-0 top-0 flex flex-col z-30">
      <div className="p-6 border-b border-[#1a1a2e]">
        <BrandLogo />
      </div>

      <nav className="flex-1 p-4 flex flex-col gap-1 overflow-y-auto scrollbar-hide">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-300 font-mono text-xs uppercase tracking-wider ${
                isActive
                  ? 'bg-[#00f0ff]/10 text-[#00f0ff] border-l-2 border-[#00f0ff] shadow-[inset_4px_0_12px_rgba(0,240,255,0.05)]'
                  : 'text-gray-500 hover:bg-[#1a1a2e] hover:text-gray-300 border-l-2 border-transparent'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="text-lg" />
            {item.label}
          </NavLink>
        ))}
      </nav>
      
      <div className="p-4 border-t border-[#1a1a2e]">
        <div className="bg-[#050508] p-3 rounded-lg border border-[#1a1a2e] flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-green-500 shadow-[0_0_8px_#22c55e] animate-pulse" />
            <span className="text-[9px] font-mono text-gray-500 uppercase">Secure Link</span>
          </div>
          <span className="text-[9px] font-mono text-[#00f0ff] opacity-50">v2.4.1</span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;